import React from 'react';
import P from 'prop-types';

export const Td = (props) => {
  return <td {...props}>{props.content ?? props.children}</td>;
};

Td.propTypes = {
  content: P.oneOfType([P.string, P.number, P.node]),
  children: P.node,
};
